import { SubmitAction } from "../../action/Action";
import { PromiseToast } from "../../components/async/PromiseToast";
import Button from "../../components/Button/Button";
import Form from "../../components/form/Form";
import type { TextFieldProps } from "../../components/form/TextField";
import TextField from "../../components/form/TextField";
import useField from "../../components/form/useField";
import { validationFn } from "../../components/form/utilities";
import LightPageLayout from "../../components/Page/LightPageLayout";
import PageHeader from "../../components/Page/PageHeader";
import Spacer from "../../components/space/Spacer";
import Text from "../../components/Text";
import { selectProjet } from "../../data/selectedProjet";
import { callOutgoingRequest } from "../../data/tanstack-query";
import { createProject, joinProjet } from "../../endpoints/outgoing-requests";
import useSubmit from "../../hooks/useSubmit";
import { navigate } from "../../navigation/location";
import { loggedInHomeRoute } from "../../navigation/routes";

export default function CreateProjectPage() {
    const [onCreate, creating] = useSubmit(async () => {
        const projet = await callOutgoingRequest(createProject());
        selectProjet(projet.id);
        navigate(loggedInHomeRoute.getLocation());
    }, []);
    const codeField = useField<TextFieldProps>({
        value: undefined,
        label: "Code",
        required: true,
        validator: validationFn("join-session", (value) => {
            if (!/^\d{9}$/.test(value.replace(/[\s-]/g, ""))) {
                throw new Error("Saisissez les 9 chiffres du code");
            }
        }),
    });
    const [onJoin, joining] = useSubmit(async (code: string) => {
        const projet = await callOutgoingRequest(joinProjet(code));
        selectProjet(projet.id);
        navigate(loggedInHomeRoute.getLocation());
    }, []);
    const onSubmitCode = () => {
        let code: string;
        try {
            code = codeField.validate();
        } catch {
            return;
        }
        onJoin(code);
    };
    return (
        <LightPageLayout>
            <PromiseToast promise={creating} message="Projet créé" />
            <PromiseToast promise={joining} message="Projet rejoint" />
            <PageHeader title="Commencer mon projet d'adoption" />
            <Button label="Créer un projet" action={onCreate} />
            <Spacer scale={8} />
            <Text variant="heading3">Rejoindre un projet</Text>
            <Spacer scale={3} />
            <Text variant="body">
                Si quelqu'un vous a communiqué un code, saisissez-le pour rejoindre son projet.
            </Text>
            <Spacer scale={4} />
            <Form onSubmit={onSubmitCode}>
                <TextField {...codeField.props} />
                <Spacer scale={4} />
                <Button label="Rejoindre le projet" action={SubmitAction} />
            </Form>
        </LightPageLayout>
    );
}
